<template>
	
	<div class="input_dialog" v-if="displayed">
		<div class="inner">			
			<div class="title">{{title}}</div>
			<div class="msg" v-html="msg"></div>
			<div class="p-4 w-full mb-2">
				<input ref="input" v-model="value" class="py-4 w-full input-text" :placeholder="placeholder" @keyup.enter="ok" />
			</div>
			<div class="btn">
				<div class="cancel" @click="cancel()">Abbrechen</div>
				<div class="ok" ref="ok" @click="ok()">Ok</div>
			</div>
		</div>
	</div>
	
</template>

<script>
  
	export default {
		name: 'InputDialog',
		inject: [
			'trans'
		],
		components: {
			
		},
		data() {
			return {
				displayed: false,
				title: 'Titel',
				msg: 'Nachricht',
				cb_ok: undefined,
				cb_cancel: undefined,
				value: ''
			}
		},
		methods: {
			
			show(title, msg, placeholder, cb_ok, cb_cancel) {
				
				this.title = title;
				this.msg = msg;
				this.placeholder = placeholder;
				this.cb_ok = cb_ok;
				this.cb_cancel = cb_cancel;
				this.value = '';
				
				this.displayed = true;

				this.$nextTick(() => {

					this.$refs.input.focus();

				});

			},
			cancel() {

				this.displayed = false;

				if (this.cb_cancel !== undefined) {

					this.cb_cancel();

				}

			},
			ok() {

				this.displayed = false;

				if (this.cb_ok !== undefined) {

					this.cb_ok(this.value);

				}
				
			}
			
		},
		mounted() {



		}
	}

</script>

<style lang="scss">
	
	.input_dialog { z-index:100; position:fixed; left:0; top:0; width:100vw; height:100vh; background-color:rgba(0, 0, 0, 0.5); display:flex; justify-content:center; align-items:center;
		.inner { background-color:#FFFFFF; border-radius:10px; width:300px; display:flex; flex-direction:column; justify-content:stretch; align-items:stretch; overflow:hidden;
			.title { width:100%; padding:15px 0; text-align:center; font-weight:bold; font-size:1.2em; }
			.msg { padding:0 15px 5px 15px; text-align:center; flex-grow:1; }			
			.btn { width:100%; border-top:1px solid #999999; display:flex; justify-content:stretch; flex-direction:row;
				& > div { flex-grow:1; text-align:center; height:45px; width:100%; display:flex; justify-content:center; align-items:center; cursor:pointer; color: rgba(59, 130, 246); font-weight:bold;
					&:hover { background-color:rgba(59, 130, 246); color:#FFFFFF; }
				}
			}
			.btn {
				& > div:nth-child(1) { border-right:1px solid #999999; }
				& > div:last-child { border-right:0; }
			}
		}
	}

</style>